import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=cfcafc14&scoped=true&"
import script from "./footer.vue?vue&type=script&lang=js&"
export * from "./footer.vue?vue&type=script&lang=js&"
import style0 from "./footer.vue?vue&type=style&index=0&id=cfcafc14&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../tmp/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfcafc14",
  null
  
)

export default component.exports